import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface AlertIconProps {
  mainColor?: string;
  secondaryColor?: string;
  height?: string;
  width?: string;
  style?: React.CSSProperties;
}

export default function AlertIcon({
  mainColor = RoutalPalette.error.medium,
  secondaryColor = RoutalPalette.white,
  height = `25px`,
  width = `25px`,
  style = {},
}: AlertIconProps) {
  return (
    <SvgIcon viewBox="0 0 25 25" fill="none" style={{ width: width, height: height, ...style }}>
      <g clip-path="url(#clip0_489_16420)">
        <path
          d="M10.3641 4.35996L1.89412 18.5C1.71949 18.8024 1.62708 19.1453 1.62611 19.4945C1.62513 19.8437 1.71561 20.1871 1.88854 20.4905C2.06148 20.7939 2.31084 21.0467 2.61183 21.2238C2.91281 21.4009 3.25492 21.4961 3.60412 21.5H20.5441C20.8933 21.4961 21.2354 21.4009 21.5364 21.2238C21.8374 21.0467 22.0868 20.7939 22.2597 20.4905C22.4326 20.1871 22.5231 19.8437 22.5221 19.4945C22.5212 19.1453 22.4287 18.8024 22.2541 18.5L13.7841 4.35996C13.6058 4.06607 13.3548 3.82308 13.0553 3.65444C12.7558 3.48581 12.4179 3.39722 12.0741 3.39722C11.7304 3.39722 11.3924 3.48581 11.0929 3.65444C10.7934 3.82308 10.5424 4.06607 10.3641 4.35996Z"
          fill={mainColor}
          stroke={mainColor}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path d="M12.0741 9.5V13.5" stroke={secondaryColor} stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M12.0741 17.5H12.0841"
          stroke={secondaryColor}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_489_16420">
          <rect width="24" height="24" fill={secondaryColor} transform="translate(0.0740967 0.5)" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
